module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-motivation-getting-help@3x.016ec9ba.png";